<template>
  <div class="page-wrapper">
    <v-container fluid class="h-100">
      <v-app-bar app style="z-index: 3;">
        <v-app-bar-nav-icon @click="drawer = !drawer"/>
<!--        <div v-if="selectedVendor !== -1">-->
<!--          {{vendorList[selectedVendor].title}}-->
<!--          <v-btn icon>-->
<!--            <v-icon>mdi-magnify</v-icon>-->
<!--          </v-btn>-->
<!--        </div>-->
        <div v-if="selectedVendor == -1">
          Select Vendor
        </div>

        <input v-if="selectedVendor >= 0" v-model="searchFilter" class="form-control" placeholder="Search products"/>

        <div v-if="selectedVendor >= 0" v-on:click="searchFilter = ''">
          <span style="font-size: 20px; padding-left: 10px;"><i class="fas fa-times"></i></span>
        </div>
<!--        <v-autocomplete-->
<!--          v-if="selectedVendor >= 0"-->
<!--          clearable-->
<!--          filled dense hide-details-->
<!--          :items="menus"-->
<!--          v-model="searchInput"-->
<!--          :search-input.sync="search"-->
<!--          item-text="title"-->
<!--          :label="vendorList[selectedVendor].title + ' Search product'">-->

<!--        </v-autocomplete>-->
      </v-app-bar>
      <v-navigation-drawer v-model:value="drawer" style="background: lightgray" app>
        <v-list flat>
          <v-list-item-group v-model="selectedVendor" color="primary">
            <v-list-item   v-for="(vendor, index) in vendorList" :key="vendor.id" class="list-group-item" v-on:click="selectVendor(index)">
              {{vendor.title}}
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <br><br><br>
      </v-navigation-drawer>
      <div class="row" style="height: calc(100% - 20px);">
        <div class="col-12 h-100"  style="overflow-y:scroll; padding-bottom:10px;">
          <span v-if="selectedVendor === -1">
            <v-list flat>
              <v-list-item-group
                v-model="selectedVendor"
                color="primary">
                  <v-list-item v-for="(vendor, index) in vendorList" :key="vendor.id"
                               class="list-group-item"
                               v-on:click="selectVendor(index)">
                    {{vendor.title}}
                  </v-list-item>
              </v-list-item-group>
            </v-list>
          </span>
          <div class="product-item-container" v-for="menu in menus"
               v-on:click="onClickRow(menu)"
               v-if="searchFilter == null || searchFilter.length == 0 || menu.title.toLowerCase().includes(searchFilter.toLowerCase())"
               v-bind:class="{'basket-item-count-active': getBasketItemCount(menu.id) > 0, 'product-border': menu.highlightProduct === true}" >
            <template  v-if="selectedVendor === 0">
            <div class="product-image-container" v-if="menu.imageUrls.length > 0">
              <div v-bind:style="{backgroundImage: 'url(' + menu.imageUrls[0] + ')'}">

              </div>
            </div>
            <div v-else class="product-image-container" style="background: #dadada; width: 100px; text-align:center; min-width: 100px;border-radius: 10px; line-height: 100px; color: white;">
              No Image
            </div>
            </template>
            <div class="product-item-info-container" v-bind:class="{'full-width':  menu.imageUrls.length === 0 || selectedVendor > 0}">
              <div class="product-title-container" style="padding: 10px;">
                <div style="font-weight: bold;">
                  {{menu.title}}
                </div>
                <div v-if="menu.unitDescription !== null && menu.unitDescription.length > 0">{{menu.unitDescription}}</div>

                <div v-else-if="menu.unitAmount > 1" style="margin-top:10px;">
                  <span style="border:1px solid #ccc; border-radius:5px; padding:5px;">{{menu.unitAmount}} unit per {{menu.unit}}</span>
                </div>
                <div v-if="menu.available === false" style="margin-top:5px;">
                  <span style="font-weight: bold; color:red;">N/A</span>
                </div>
                <div v-if="menu.available === true" style="width: 100%;">
                  <table style="width: 100%; margin-top: 10px;">
                    <tr>
                      <td>
                        <div style="font-weight: bold; width: 40%; height: 40px; line-height: 40px; text-align: left;">
                          <span v-if="selectedVendor === 0 || menu.priceFloat > 0">£{{menu.priceFloat.toFixed(2)}}</span>

                        </div>
<!--                        <div v-if="merchant.tags.length > 0 && menu.noMarginTags.length > 0 && isNoMarginTagFound(menu)" style="color: red;">-->
<!--                          * No margin price-->
<!--                        </div>-->
                      </td>
                      <td style="width: 60px;">
                        <span class="basket-item-remove" v-on:click.stop="onRemoveClicked(menu)"><i class="fas fa-trash"></i></span>
                      </td>
                      <td class="text-right" style="width: 40px;">
                        <div class="basket-item-count"  v-on:click.stop="onAddClicked(menu)">{{getBasketItemCount(menu.id)}}</div>
                      </td>
                    </tr>
                  </table>






                </div>

              </div>
<!--              <strong>£{{(menu.price/100).toFixed(2)}}</strong><br>-->
<!--              <span v-if="menu.taxRate==0">Zero Rated VAT</span>-->
<!--              <span v-else>VAT £{{ ((menu.price * menu.taxRate/10000)/100).toFixed(2)}}</span>-->
            </div>

          </div>
        </div>
        <div style="width: 100%; height: 20px; line-height: 20px; text-align: center;">
          All prices are VAT exclusive.
        </div>
      </div>
      <v-dialog
        v-model="addBasketDialog"
        width="90%">
        <detail-product
          v-if="selectedItem !== null"
          v-model="selectedItem"
          :enableMemo="selectedVendor==0"
          :vendor-name="vendorList[selectedVendor].title"
          v-on:addItem="onAddToBasket"/>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
  import {getDeliveryDates, getVendorList} from "../api/vendor";

    require('@/assets/css/styles.css')

  import {getCategories, getCategoryItems, getProducts} from "../api/product";
    import {showDialog} from "../api/utils";
    import DetailProduct from "./Detail";
    import {getDeliveryDay, loadBasket, newChildOrder, saveBasket} from "../api/order";
    import EventBus from "../api/event-bus";
  import {getMyMerchant} from "../api/user";

    export default {
        name: "Home",
        data() {
          return {
            categories:[],
            showCategory:true,
            menus:[],
            selectedCategory: -1,
            loadingMenu:false,
            drawer: null,
            headers: [
              { text: 'Title', width: "40%", value: 'title' },
              { text: 'Stock', width: "15%", value: 'currentStock' },
              { text: 'Unit', width: "15%", value: 'unit' },
              { text: 'Prise (£)', value: 'price' },
            ],
            addBasketDialog: false,
            selectedItem: null,
            vendorList: [],
            selectedVendor: -1,
            deliveryDates: new Array(7),

            searchInput: null,
            searchFilter:null,
            basket: false,
            merchant: null,
          }
        },
        components: {
          DetailProduct
        },
        created() {
          EventBus.$on('onBasketChanged', this.onBasketChanged);
        },
        mounted(){
          this.$data.basket = false;
          this.initialise();
        },
        beforeRouteUpdate(to, from, next) {
          console.log("beforeRouteUpdate");

          next();
        },
        beforeDestroy() {
          setListeners(false, false, false);
        },
        computed: {
          search: {
            get() {

            },
            set(searchInput) {
              // console.log("Search input " + searchInput);
              this.searchFilter = searchInput;
            }
          }
        },
        watch: {
          searchInput(val) {
            console.log("new Search input " + val);
          }
        },
        methods: {
          initialise: function() {
            let self = this;
            getMyMerchant()
              .then(function(data) {
                if(data.success) {
                  self.$data.merchant = data.item;
                  self.getCategoryList();
                  self.getVendorList();
                  self.getDeliveryDates();
                  EventBus.$emit("checkNotice");
                }
              });
          },
          isNoMarginTagFound: function(product) {
            if(this.$data.merchant.tags === null || this.$data.merchant.tags.length === 0) {
              return false;
            }
            if(product.noMarginTags === null || product.noMarginTags.length === 0) {
              return false;
            }

            for(let t = 0 ; t < product.noMarginTags.length ; t++) {
              for(let mt = 0 ; mt < this.$data.merchant.tags.length  ; mt++) {
                if(product.noMarginTags[t] === this.$data.merchant.tags[mt]) {
                  return true;
                }
              }
            }
            return false;
          },
          toggleCategoryList: function() {
            this.$data.showCategory = !this.$data.showCategory;
          },
          getDeliveryDates: function () {
            let self = this;
            getDeliveryDates()
              .then((data) => {
                // console.log(data.item)

                for(let date of data.item) {
                  if(date.selected) {
                    this.deliveryDates[date.deliveryDay] = date
                  }
                }
              })
          },
          getCategoryList:function() {
            let self = this;
            getCategories()
            .then(function(data) {
              if(data.success == true) {
                self.$data.categories = data.item;
              } else {
                showDialog(data.message, "No categories");
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
          },
          openCategory: function(category) {
            this.drawer = null
            this.menus = []
            this.loadingMenu = true

            this.$data.selectedCategory = category;
            let self = this;
            getCategoryItems(category.id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.menus = data.item;
              }
            })
            .catch(function(err) {

            }).finally(function () {
              self.loadingMenu = false
              console.log(self.loadingMenu)
            })
          },
          // openMenu: function(menu) {
          //   this.$data.selectedMenu = menu;
          // },
          onClickRow: function(item){
            if(item.available == false) {
              return;
            }
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.selectedItem.amount = 1;
            this.addBasketDialog = true
          },
          onRemoveClicked: function(item) {
            let basketOrder = loadBasket(this.vendorList[this.selectedVendor].id)
            let found = false;
            console.log("basket to remove basket");
            console.log(basketOrder);
            if(basketOrder.list != null && basketOrder.list.length > 0) {
              for(let i = basketOrder.list.length - 1 ; i >= 0 ; i--) {
                console.log("Basket " + i + " PID:" + basketOrder.list[i].productId + " VID:" + basketOrder.vendorId);
                if (basketOrder.list[i].productId == item.id && basketOrder.vendorId == this.vendorList[this.selectedVendor].id) {
                  basketOrder.list.splice(i, 1);
                }
              }
            }
            let totalPrice = 0;
            let tax = 0;
            for(let i = 0 ; i < basketOrder.list.length ; i++) {
              totalPrice += basketOrder.list[i].totalPrice;
              tax += basketOrder.list[i].tax;
            }

            basketOrder.totalPrice = totalPrice;
            basketOrder.tax = tax;
            basketOrder.finalDue = totalPrice + tax;
            this.$data.basket = JSON.parse(JSON.stringify(basketOrder));
            saveBasket(basketOrder, this.vendorList[this.selectedVendor].id)
            EventBus.$emit('onBasket',1);

            this.addBasketDialog = false
          },
          onAddClicked: function(item) {
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.selectedItem.amount = 1;
            this.onAddToBasket(this.vendorList[this.selectedVendor].id);
          },

          onAddToBasket: function(vendorId, memo = ''){
            EventBus.$emit('onBasket', 1)
            console.log("add basket " + vendorId + " currentVendor " + this.vendorList[this.selectedVendor].id);
            console.log(this.vendorList[this.selectedVendor]);
            let basketOrder = loadBasket(this.vendorList[this.selectedVendor].id)
            console.log(basketOrder);

            if(basketOrder.vendorId == 0) {
              basketOrder.deliveryDate = getDeliveryDay(this.$data.deliveryDates);
            }

            let found = false;
            console.log("basket");
            console.log(basketOrder);
            if(basketOrder.list != null && basketOrder.list.length > 0) {
              for(let i = 0 ; i < basketOrder.list.length ; i++) {
                console.log("Basket " + i + " PID:" + basketOrder.list[i].productId + " VID:" + basketOrder.vendorId);
                if(basketOrder.list[i].productId == this.selectedItem.id && basketOrder.vendorId == this.vendorList[this.selectedVendor].id) {
                  console.log("Found to Increment current item " + basketOrder.list[i].amount + ' by ' + this.selectedItem.amount);
                  basketOrder.list[i].amount += this.selectedItem.amount;
                  basketOrder.list[i].totalPrice = basketOrder.list[i].price*basketOrder.list[i].amount;
                  basketOrder.list[i].tax = basketOrder.list[i].totalPrice * basketOrder.list[i].taxRate/10000;
                  basketOrder.list[i].finalDue = basketOrder.list[i].totalPrice + basketOrder.list[i].tax;
                  console.log("Increment current item " + basketOrder.list[i].amount);
                  found = true;
                  break;
                }
              }
            }

            if(found == false) {
              let newOrder = newChildOrder(this.selectedItem, memo)


              for(let i = 0 ; i < this.$data.categories.length ; i++) {
                if(this.$data.categories[i].id === newOrder.categoryId) {
                  newOrder.categoryTitle = this.$data.categories[i].title;
                }
              }
              console.log(newOrder);
              basketOrder.list.push(newOrder)

            }
            let totalPrice = 0;
            let tax = 0;
            for(let i = 0 ; i < basketOrder.list.length ; i++) {
              totalPrice += basketOrder.list[i].totalPrice;
              tax += basketOrder.list[i].tax;
            }

            basketOrder.totalPrice = totalPrice;
            basketOrder.tax = tax;
            basketOrder.finalDue = totalPrice + tax;
            this.$data.basket = JSON.parse(JSON.stringify(basketOrder));
            saveBasket(basketOrder, this.vendorList[this.selectedVendor].id)
            EventBus.$emit('onBasket',1);

            this.addBasketDialog = false

          },
          getBasketItemCount: function(pid) {
            if(this.$data.basket == false) {
              return 0;
            }
            if(this.$data.basket.list === undefined || this.$data.basket.list === null || this.$data.basket.list.length == 0) {
              return 0;
            }

            for(let i = 0 ; i < this.$data.basket.list.length ; i++) {
              if(this.$data.basket.list[i].productId === pid) {
                // console.log("Basket Item Found to count ");
                // console.log(this.$data.basket.list[i]);
                return this.$data.basket.list[i].amount;
              }
            }
            return 0;
          },
          onBasketChanged: function() {
            console.log("onBasketChanged");
            console.log(this.vendorList);
            if(this.vendorList.length === 0) {
              this.$data.basket = false;
            } else {
              this.$data.basket = loadBasket(this.vendorList[this.selectedVendor].id);
            }
          },
          selectVendor: function(index) {
            this.$data.selectedVendor = index;
            this.drawer = null
            this.menus = []
            this.loadingMenu = true

            this.$data.basket = loadBasket(this.vendorList[this.selectedVendor].id)
            let self = this;
            getProducts(this.$data.vendorList[index].id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < data.item.length ; i++) {
                  if(data.item[i].price == 0 && data.item[i].sourcePrice  > 0) {
                    data.item[i].price = data.item[i].sourcePrice;
                  }
                }
                self.menus = data.item;
              } else {

              }
            })
            .catch(function(err) {

            })
          },
          getVendorList: function() {
            let vm = this
            getVendorList()
              .then(data => {
                console.log(data)

                vm.vendorList.push(
                  {
                    id:0,
                    title:'KOKORO',
                    logo:'/static/img/logo-white-ic.png',
                  }
                )
                for(let vendor of data.item) {
                  vm.vendorList.push(vendor);
                }
                localStorage.setItem("vendor_list", JSON.stringify(vm.vendorList));
              })
          },
        }
    }
</script>

<style lang="css" scoped>
  .v-list-item--active {
    color: white;
    background-color: gray;
  }
  .basket-item-count {
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    background-color: #999999;
    color:white;
  }


  .basket-item-remove {

    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    background-color: white;
    color:#e7344c;
    display:none;
  }

  .basket-item-count-active .basket-item-count{
    background-color: #43C568;
    color:white;
  }
  .product-border .basket-item-count{
    background-color: #ec5900;
    color:white;
  }
  .basket-item-count-active .basket-item-remove {
    color:#e7344c;
    display: block;
  }
  .basket-item-count-active .basket-item-remove .fa-trash{
    color: #e7344c;
  }
  .product-border.basket-item-count-active {
    border-left: 5px solid #ec5900;
  }
  .product-border {

    border: 1px solid #ec5900;
    background: #fde1d3;
    border-radius: 5px;
    padding-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue